(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name RevistasController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('RevistasController', RevistasController);

    RevistasController.$inject = ["RevistaService","$timeout","$location",'$anchorScroll','$window','AnaliticaService'];

    function RevistasController(RevistaService,$timeout,$location,$anchorScroll,$window,AnaliticaService)
    {
    	var vm = this;
        vm.ano = "";
        vm.revistas = [];
        vm.loading = false;
        vm.getRevistas = function(){
            vm.loading = true;
            RevistaService.getRevistas(vm.ano,function(data){
                vm.loading = false;
                vm.revistas = data.revistas;
            },function(){vm.loading = false;});
        };
        vm.downloadEvent = function(revSlug, url,nombre){
            console.log('Descarga: '+nombre + revSlug+url+'/downloaded');
            AnaliticaService.pageView('Descarga: '+nombre,revSlug+url+'/downloaded',revSlug+url+'/downloaded');
        };

    }


})();